import { render } from "./FilterOwnMedia.vue?vue&type=template&id=10fdcff8"
import script from "./FilterOwnMedia.vue?vue&type=script&lang=js"
export * from "./FilterOwnMedia.vue?vue&type=script&lang=js"

import "./FilterOwnMedia.vue?vue&type=style&index=0&id=10fdcff8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__